/**
 * Ekman Upwelling (W_E) portal configuration.
 * Auto-updated by ekman_io.py / run_ekman_daily.py.
 * Three data sources, all Indo-Pacific only (tuna migration tool):
 *   - metop  : MetOp-A+B ASCAT historical (2007-present, monthly)
 *   - cfs    : CFSv2 seasonal forecast (~9 months ahead, monthly)
 *   - gfs    : GFS short-range forecast (16 days, daily)
 */

// ── MetOp historical ─────────────────────────────────────────────────────────
// Populated by ekman_io.py from pacific_ekman_ascat_stitched_AB.nc
export const ekmanMetopDates = [
  "EKMAN_METOP_2007-01",
  "EKMAN_METOP_2007-02",
  "EKMAN_METOP_2007-03",
  "EKMAN_METOP_2007-04",
  "EKMAN_METOP_2007-05",
  "EKMAN_METOP_2007-06",
  "EKMAN_METOP_2007-07",
  "EKMAN_METOP_2007-08",
  "EKMAN_METOP_2007-09",
  "EKMAN_METOP_2007-10",
  "EKMAN_METOP_2007-11",
  "EKMAN_METOP_2007-12",
  "EKMAN_METOP_2008-01",
  "EKMAN_METOP_2008-02",
  "EKMAN_METOP_2008-03",
  "EKMAN_METOP_2008-04",
  "EKMAN_METOP_2008-05",
  "EKMAN_METOP_2008-06",
  "EKMAN_METOP_2008-07",
  "EKMAN_METOP_2008-08",
  "EKMAN_METOP_2008-09",
  "EKMAN_METOP_2008-10",
  "EKMAN_METOP_2008-11",
  "EKMAN_METOP_2008-12",
  "EKMAN_METOP_2009-01",
  "EKMAN_METOP_2009-02",
  "EKMAN_METOP_2009-03",
  "EKMAN_METOP_2009-04",
  "EKMAN_METOP_2009-05",
  "EKMAN_METOP_2009-06",
  "EKMAN_METOP_2009-07",
  "EKMAN_METOP_2009-08",
  "EKMAN_METOP_2009-09",
  "EKMAN_METOP_2009-10",
  "EKMAN_METOP_2009-11",
  "EKMAN_METOP_2009-12",
  "EKMAN_METOP_2010-01",
  "EKMAN_METOP_2010-02",
  "EKMAN_METOP_2010-03",
  "EKMAN_METOP_2010-04",
  "EKMAN_METOP_2010-05",
  "EKMAN_METOP_2010-06",
  "EKMAN_METOP_2010-07",
  "EKMAN_METOP_2010-08",
  "EKMAN_METOP_2010-09",
  "EKMAN_METOP_2010-10",
  "EKMAN_METOP_2010-11",
  "EKMAN_METOP_2010-12",
  "EKMAN_METOP_2011-01",
  "EKMAN_METOP_2011-02",
  "EKMAN_METOP_2011-03",
  "EKMAN_METOP_2011-04",
  "EKMAN_METOP_2011-05",
  "EKMAN_METOP_2011-06",
  "EKMAN_METOP_2011-07",
  "EKMAN_METOP_2011-08",
  "EKMAN_METOP_2011-09",
  "EKMAN_METOP_2011-10",
  "EKMAN_METOP_2011-11",
  "EKMAN_METOP_2011-12",
  "EKMAN_METOP_2012-01",
  "EKMAN_METOP_2012-02",
  "EKMAN_METOP_2012-03",
  "EKMAN_METOP_2012-04",
  "EKMAN_METOP_2012-05",
  "EKMAN_METOP_2012-06",
  "EKMAN_METOP_2012-07",
  "EKMAN_METOP_2012-08",
  "EKMAN_METOP_2012-09",
  "EKMAN_METOP_2012-10",
  "EKMAN_METOP_2012-11",
  "EKMAN_METOP_2012-12",
  "EKMAN_METOP_2013-01",
  "EKMAN_METOP_2013-02",
  "EKMAN_METOP_2013-03",
  "EKMAN_METOP_2013-04",
  "EKMAN_METOP_2013-05",
  "EKMAN_METOP_2013-06",
  "EKMAN_METOP_2013-07",
  "EKMAN_METOP_2013-08",
  "EKMAN_METOP_2013-09",
  "EKMAN_METOP_2013-10",
  "EKMAN_METOP_2013-11",
  "EKMAN_METOP_2013-12",
  "EKMAN_METOP_2014-01",
  "EKMAN_METOP_2014-02",
  "EKMAN_METOP_2014-03",
  "EKMAN_METOP_2014-04",
  "EKMAN_METOP_2014-05",
  "EKMAN_METOP_2014-06",
  "EKMAN_METOP_2014-07",
  "EKMAN_METOP_2014-08",
  "EKMAN_METOP_2014-09",
  "EKMAN_METOP_2014-10",
  "EKMAN_METOP_2014-11",
  "EKMAN_METOP_2014-12",
  "EKMAN_METOP_2015-01",
  "EKMAN_METOP_2015-02",
  "EKMAN_METOP_2015-03",
  "EKMAN_METOP_2015-04",
  "EKMAN_METOP_2015-05",
  "EKMAN_METOP_2015-06",
  "EKMAN_METOP_2015-07",
  "EKMAN_METOP_2015-08",
  "EKMAN_METOP_2015-09",
  "EKMAN_METOP_2015-10",
  "EKMAN_METOP_2015-11",
  "EKMAN_METOP_2015-12",
  "EKMAN_METOP_2016-01",
  "EKMAN_METOP_2016-02",
  "EKMAN_METOP_2016-03",
  "EKMAN_METOP_2016-04",
  "EKMAN_METOP_2016-05",
  "EKMAN_METOP_2016-06",
  "EKMAN_METOP_2016-07",
  "EKMAN_METOP_2016-08",
  "EKMAN_METOP_2016-09",
  "EKMAN_METOP_2016-10",
  "EKMAN_METOP_2016-11",
  "EKMAN_METOP_2016-12",
  "EKMAN_METOP_2017-01",
  "EKMAN_METOP_2017-02",
  "EKMAN_METOP_2017-03",
  "EKMAN_METOP_2017-04",
  "EKMAN_METOP_2017-05",
  "EKMAN_METOP_2017-06",
  "EKMAN_METOP_2017-07",
  "EKMAN_METOP_2017-08",
  "EKMAN_METOP_2017-09",
  "EKMAN_METOP_2017-10",
  "EKMAN_METOP_2017-11",
  "EKMAN_METOP_2017-12",
  "EKMAN_METOP_2018-01",
  "EKMAN_METOP_2018-02",
  "EKMAN_METOP_2018-03",
  "EKMAN_METOP_2018-04",
  "EKMAN_METOP_2018-05",
  "EKMAN_METOP_2018-06",
  "EKMAN_METOP_2018-07",
  "EKMAN_METOP_2018-08",
  "EKMAN_METOP_2018-09",
  "EKMAN_METOP_2018-10",
  "EKMAN_METOP_2018-11",
  "EKMAN_METOP_2018-12",
  "EKMAN_METOP_2019-01",
  "EKMAN_METOP_2019-02",
  "EKMAN_METOP_2019-03",
  "EKMAN_METOP_2019-04",
  "EKMAN_METOP_2019-05",
  "EKMAN_METOP_2019-06",
  "EKMAN_METOP_2019-07",
  "EKMAN_METOP_2019-08",
  "EKMAN_METOP_2019-09",
  "EKMAN_METOP_2019-10",
  "EKMAN_METOP_2019-11",
  "EKMAN_METOP_2019-12",
  "EKMAN_METOP_2020-01",
  "EKMAN_METOP_2020-02",
  "EKMAN_METOP_2020-03",
  "EKMAN_METOP_2020-04",
  "EKMAN_METOP_2020-05",
  "EKMAN_METOP_2020-06",
  "EKMAN_METOP_2020-07",
  "EKMAN_METOP_2020-08",
  "EKMAN_METOP_2020-09",
  "EKMAN_METOP_2020-10",
  "EKMAN_METOP_2020-11",
  "EKMAN_METOP_2020-12",
  "EKMAN_METOP_2021-01",
  "EKMAN_METOP_2021-02",
  "EKMAN_METOP_2021-03",
  "EKMAN_METOP_2021-04",
  "EKMAN_METOP_2021-05",
  "EKMAN_METOP_2021-06",
  "EKMAN_METOP_2021-07",
  "EKMAN_METOP_2021-08",
  "EKMAN_METOP_2021-09",
  "EKMAN_METOP_2021-10",
  "EKMAN_METOP_2021-11",
  "EKMAN_METOP_2021-12",
  "EKMAN_METOP_2022-01",
  "EKMAN_METOP_2022-02",
  "EKMAN_METOP_2022-03",
  "EKMAN_METOP_2022-04",
  "EKMAN_METOP_2022-05",
  "EKMAN_METOP_2022-06",
  "EKMAN_METOP_2022-07",
  "EKMAN_METOP_2022-08",
  "EKMAN_METOP_2022-09",
  "EKMAN_METOP_2022-10",
  "EKMAN_METOP_2022-11",
  "EKMAN_METOP_2022-12",
  "EKMAN_METOP_2023-01",
  "EKMAN_METOP_2023-02",
  "EKMAN_METOP_2023-03",
  "EKMAN_METOP_2023-04",
  "EKMAN_METOP_2023-05",
  "EKMAN_METOP_2023-06",
  "EKMAN_METOP_2023-07",
  "EKMAN_METOP_2023-08",
  "EKMAN_METOP_2023-09",
  "EKMAN_METOP_2023-10",
  "EKMAN_METOP_2023-11",
  "EKMAN_METOP_2023-12",
  "EKMAN_METOP_2024-01",
  "EKMAN_METOP_2024-02",
  "EKMAN_METOP_2024-03",
  "EKMAN_METOP_2024-04",
  "EKMAN_METOP_2024-05",
  "EKMAN_METOP_2024-06",
  "EKMAN_METOP_2024-07",
  "EKMAN_METOP_2024-08",
  "EKMAN_METOP_2024-09",
  "EKMAN_METOP_2024-10",
  "EKMAN_METOP_2024-11",
  "EKMAN_METOP_2024-12",
  "EKMAN_METOP_2025-01",
  "EKMAN_METOP_2025-02",
  "EKMAN_METOP_2025-03",
  "EKMAN_METOP_2025-04",
  "EKMAN_METOP_2025-05",
  "EKMAN_METOP_2025-06",
  "EKMAN_METOP_2025-07",
  "EKMAN_METOP_2025-08",
  "EKMAN_METOP_2025-09",
  "EKMAN_METOP_2025-10",
  "EKMAN_METOP_2025-11",
  "EKMAN_METOP_2025-12",
  "EKMAN_METOP_2026-01",
  "EKMAN_METOP_2026-02"
];

// ── CFS forecast ──────────────────────────────────────────────────────────────
// Each stem is the FGB filename without extension (e.g. "EKMAN_CFS_2026-07")
export const ekmanCfsDates = [
  "EKMAN_CFS_2026-07",
  "EKMAN_CFS_2026-08",
  "EKMAN_CFS_2026-09",
  "EKMAN_CFS_2026-10",
  "EKMAN_CFS_2026-11",
  "EKMAN_CFS_2026-12",
  "EKMAN_CFS_2027-01",
  "EKMAN_CFS_2027-02",
  "EKMAN_CFS_2027-03"
];

// ── GFS forecast ──────────────────────────────────────────────────────────────
export const ekmanGfsDates = [
  "EKMAN_GFS_2026-07-29T06",
  "EKMAN_GFS_2026-07-29T12",
  "EKMAN_GFS_2026-07-29T18",
  "EKMAN_GFS_2026-07-30T00",
  "EKMAN_GFS_2026-07-30T06",
  "EKMAN_GFS_2026-07-30T12",
  "EKMAN_GFS_2026-07-30T18",
  "EKMAN_GFS_2026-07-31T00",
  "EKMAN_GFS_2026-07-31T06",
  "EKMAN_GFS_2026-07-31T12",
  "EKMAN_GFS_2026-07-31T18",
  "EKMAN_GFS_2026-08-01T00",
  "EKMAN_GFS_2026-08-01T06",
  "EKMAN_GFS_2026-08-01T12",
  "EKMAN_GFS_2026-08-01T18",
  "EKMAN_GFS_2026-08-02T00",
  "EKMAN_GFS_2026-08-02T06",
  "EKMAN_GFS_2026-08-02T12",
  "EKMAN_GFS_2026-08-02T18",
  "EKMAN_GFS_2026-08-03T00",
  "EKMAN_GFS_2026-08-03T06",
  "EKMAN_GFS_2026-08-03T12",
  "EKMAN_GFS_2026-08-03T18",
  "EKMAN_GFS_2026-08-04T00",
  "EKMAN_GFS_2026-08-04T06",
  "EKMAN_GFS_2026-08-04T12",
  "EKMAN_GFS_2026-08-04T18",
  "EKMAN_GFS_2026-08-05T00",
  "EKMAN_GFS_2026-08-05T06",
  "EKMAN_GFS_2026-08-05T12",
  "EKMAN_GFS_2026-08-05T18",
  "EKMAN_GFS_2026-08-06T00",
  "EKMAN_GFS_2026-08-06T06",
  "EKMAN_GFS_2026-08-06T12",
  "EKMAN_GFS_2026-08-06T18",
  "EKMAN_GFS_2026-08-07T00",
  "EKMAN_GFS_2026-08-07T06",
  "EKMAN_GFS_2026-08-07T12",
  "EKMAN_GFS_2026-08-07T18",
  "EKMAN_GFS_2026-08-08T00",
  "EKMAN_GFS_2026-08-08T06",
  "EKMAN_GFS_2026-08-08T12",
  "EKMAN_GFS_2026-08-08T18",
  "EKMAN_GFS_2026-08-09T00",
  "EKMAN_GFS_2026-08-09T06",
  "EKMAN_GFS_2026-08-09T12",
  "EKMAN_GFS_2026-08-09T18",
  "EKMAN_GFS_2026-08-10T00",
  "EKMAN_GFS_2026-08-10T06",
  "EKMAN_GFS_2026-08-10T12",
  "EKMAN_GFS_2026-08-10T18",
  "EKMAN_GFS_2026-08-11T00",
  "EKMAN_GFS_2026-08-11T06",
  "EKMAN_GFS_2026-08-11T12",
  "EKMAN_GFS_2026-08-11T18",
  "EKMAN_GFS_2026-08-12T00",
  "EKMAN_GFS_2026-08-12T06",
  "EKMAN_GFS_2026-08-12T12",
  "EKMAN_GFS_2026-08-12T18",
  "EKMAN_GFS_2026-08-13T00",
  "EKMAN_GFS_2026-08-13T06",
  "EKMAN_GFS_2026-08-13T12",
  "EKMAN_GFS_2026-08-13T18",
  "EKMAN_GFS_2026-08-14T00"
];

// ── Shared legend / display metadata ─────────────────────────────────────────
export const ekmanVariableMetadata = {
  metop: {
    label: 'MetOp Ekman Upwelling (W_E)',
    units: 'cm/day',
    cmap: 'RdBu_r',
    vmin: -50,
    vmax: 50,
    description:
      'Monthly Ekman pumping vertical velocity derived from MetOp-A + MetOp-B ASCAT ' +
      'scatterometer winds (2007–present). Positive = upwelling.',
  },
  cfs: {
    label: 'CFS Ekman Upwelling Forecast (W_E)',
    units: 'cm/day',
    cmap: 'RdBu_r',
    vmin: -50,
    vmax: 50,
    description:
      'CFSv2 9-month seasonal Ekman pumping forecast derived from 10 m winds. ' +
      'Positive = upwelling.',
  },
  gfs: {
    label: 'GFS Ekman Upwelling Forecast (W_E)',
    units: 'cm/day',
    cmap: 'RdBu_r',
    vmin: -50,
    vmax: 50,
    description:
      'GFS 16-day Ekman pumping forecast derived from 10 m winds. ' +
      'Positive = upwelling.',
  },
};

// ── Region config (tuna view only — full Indo-Pacific) ────────────────────────
// Longitude 92–280°E (western Myanmar to 80°W), lat 50°S–55°N
export const ekmanRegionMetadata = {
  'indo-pacific': {
    // The map camera is set centrally in variableConfig.js so SST and Ekman
    // views use identical framing for the convergence-zone overlay.
    view: { latitude: 5, longitude: 186, zoom: 1.9, bearing: 0, pitch: 0 },
    // base FGB directory under /public/jsonFiles/ekman/
    cfsDir: '/jsonFiles/ekman/cfs/native',
    gfsDir: '/jsonFiles/ekman/gfs/native',
    metopDir: '/jsonFiles/ekman/metop',
  },
};
